import { mainAPI } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import {
  AvailableMetricListResponse,
  MetricDataResponse,
  MetricRequest,
} from "../types/api/metrics/request";

const path = `/monitoring/${process.env.REACT_APP_API_VERSION}/metrics`;

// Метрики - Получить список доступных
export function fetchAvailableMetrics() {
  return mainAPI.get<AvailableMetricListResponse>(`${path}`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}

// Метрика - Получить
export function fetchMetric(
  metricName: string,
  metricType: string,
  params?: MetricRequest
) {
  const filteredParams = params
    ? Object.fromEntries(
        Object.entries(params).filter(
          ([_, value]) => value !== undefined && value !== null
        )
      )
    : undefined;

  return mainAPI
    .post<MetricDataResponse>(
      `${path}/${metricName}/${metricType}`,
      filteredParams || {}
    )
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Произошла ошибка")
        );
      }
    );
}

// Метрика - Экспортировать
export function exportMetric(
  metricName: string,
  metricType: string,
  params?: MetricRequest
) {
  const filteredParams = params
    ? Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== undefined)
      )
    : undefined;

  return mainAPI
    .post(`${path}/${metricName}/${metricType}/excel`, filteredParams || {}, {
      responseType: "blob",
    })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Ошибка при экспорте метрик")
        );
      }
    );
}
